import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Недописанные сообщения по чатам.
 *
 * Оператор постоянно прыгает между диалогами и аккаунтами; без черновиков
 * набранный текст пропадал при каждом переключении.
 */
interface DraftsState {
  byChat: Record<string, string>;
  set: (chatId: string, text: string) => void;
  clear: (chatId: string) => void;
}

export const useDrafts = create<DraftsState>()(
  persist(
    (set) => ({
      byChat: {},
      set: (chatId, text) =>
        set((s) => {
          if (!text) {
            if (!(chatId in s.byChat)) return s;
            const { [chatId]: _drop, ...rest } = s.byChat;
            return { byChat: rest };
          }
          return { byChat: { ...s.byChat, [chatId]: text } };
        }),
      clear: (chatId) =>
        set((s) => {
          if (!(chatId in s.byChat)) return s;
          const { [chatId]: _drop, ...rest } = s.byChat;
          return { byChat: rest };
        }),
    }),
    { name: "tmc-drafts" }
  )
);
